module.exports = __webpack_public_path__ + "img/Marca12.459c50b1.jpg";